import { State } from './selector';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} state New state
 * @param {State} oldState Old state
 * @returns {Object} Object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { customerType, publicFactName, disableBooking } = state;
    const customerTypeChanged = customerType !== oldState.customerType;
    const publicFactNameChanged = publicFactName !== oldState.publicFactName;
    const diableBookingChanged = disableBooking !== oldState.disableBooking;
    return {
        nonBookableCard: diableBookingChanged || customerTypeChanged || publicFactNameChanged,
    };
};
